import React from 'react'

export default function WhiteSpace(props) {
    return (
        <div style={{height: props.height, width: props.width, backgroundColor:"transparent"}} className="WhiteSpace"></div>
    )
}
